import { getFallbackValueIfNull } from 'owa-options-core';
import {
    getOptionsForFeature,
    GdprAdsPrefsOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import getStore from '../store/getStore';

export default function getOptions() {
    const savedOptions = getOptionsForFeature<GdprAdsPrefsOptions>(
        OwsOptionsFeatureType.GdprAdsPrefs
    );

    const options = getStore();

    return {
        allowAccess: getFallbackValueIfNull(
            options.allowAccess,
            savedOptions.consentString ? savedOptions.allowStorageAndAccess : true
        ),

        allowAdSelection: getFallbackValueIfNull(
            options.allowAdSelection,
            savedOptions.consentString ? savedOptions.allowAdSelectionDeliveryReporting : true
        ),

        allowContentSelection: getFallbackValueIfNull(
            options.allowContentSelection,
            savedOptions.consentString ? savedOptions.allowContentSelectionDeliveryReporting : true
        ),

        allowPersonalization: getFallbackValueIfNull(
            options.allowPersonalization,
            savedOptions.consentString ? savedOptions.allowPersonalization : true
        ),

        allowMeasurement: getFallbackValueIfNull(
            options.allowMeasurement,
            savedOptions.consentString ? savedOptions.allowMeasurement : true
        ),
    };
}
